import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  selectPermissionsModal,
  setPermissionsModal,
} from "slices/devicesSlice";
import Modal from "../../HOCS/Modal";
import DPModalBody from "./DPModalBody/DPModalBody";

const DEVICE_PERMISSIONS_MODAL_DELAY = 800;

const DevicePermissionsModal = () => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const permissionsModal = useSelector(selectPermissionsModal);

  useEffect(() => {
    var timeout = null;
    if (permissionsModal) {
      timeout = setTimeout(() => {
        setShow(true);
      }, DEVICE_PERMISSIONS_MODAL_DELAY);
    } else setShow(false);
    return () => clearTimeout(timeout);
  }, [permissionsModal]);

  if (show)
    return (
      <Modal
        growth={true}
        noBackDropClick={false}
        lightBackDrop={false}
        header={
          <span
            style={{ fontSize: "18px" }}
          >{`Your mic and camera will not work unless you click "Allow" when your browser prompts you.`}</span>
        }
        content={
          <DPModalBody onDismiss={() => dispatch(setPermissionsModal(false))} />
        }
        onDismiss={() => dispatch(setPermissionsModal(false))}
      />
    );
  else return null;
};

export default DevicePermissionsModal;
